var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.photoToEdit.image)+" "),_c('b-row',[_c('b-col',{staticClass:"mb-5",attrs:{"md":"12"}},[_c('cropper-images',{attrs:{"label":"Edit Photos","images":_vm.photoToEdit.image}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }